export default __webpack_public_path__ + "static/media/presentation.cdf3250c.pptx";